import { useEffect, useRef } from "react";
import Slider from "react-slick";
// import ModalVideo from "react-modal-video";
import { Link } from "react-router-dom";
import useMobile from "../hooks/useMobile";
import useTab from "../hooks/useTab";
const BannerThree = (props) => {
  const { sliderData } = props;
  const sliderRef = useRef();
  const mobile = useMobile();
  const tab = useTab();
  // const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    let WOW;
    if (typeof window !== "undefined") {
      WOW = require("wowjs");
      const wowInstance = new WOW.WOW({ live: false });
      wowInstance.init();
    }
  }, []);

  const handleBeforeChange = () => {
    if (typeof document !== "undefined") {
      const wowElements = document.querySelectorAll(".wow");
      wowElements.forEach((el) => {
        el.style.visibility = "hidden";
        el.classList.remove("animated");
      });
    }
  };

  const handleAfterChange = () => {
    if (typeof window !== "undefined") {
      const WOW = require("wowjs");
      const wowInstance = new WOW.WOW({ live: false });
      wowInstance.init();

      const wowElements = document.querySelectorAll(".wow");
      wowElements.forEach((el) => {
        el.style.visibility = "visible";
      });
    }
  };

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 900,
    dots: false,
    pauseOnHover: true,
    arrows: false,
    draggable: true,
    infinite: true,
    fade: true,

    beforeChange: handleBeforeChange,
    afterChange: handleAfterChange,
  };
  return (
    <section
      className="banner-three position-relative responsive-arrow overflow-hidden"
      id="slider"
    >
      <button
        type="button"
        id="banner-three-prev"
        onClick={() => sliderRef.current.slickPrev()}
        className={`slick-arrow-prev slick-arrow flex-center rounded-circle bg-white text-main-600 hover-border-main-600 hover-bg-main-600 hover-text-white transition-1 position-absolute inset-inline-start-0 top-50 translate-middle-y z-3 ${!mobile && "text-2xl"} ${mobile ? "ms-8" : "ms-12"}`}
        style={{
          height: mobile ? "35px" : "default",
          width: mobile ? "35px" : "default",
        }}
      >
        <i className="ph-bold ph-arrow-left" />
      </button>
      <button
        type="button"
        id="banner-three-next"
        onClick={() => sliderRef.current.slickNext()}
        className={`slick-arrow-next slick-arrow flex-center rounded-circle bg-white text-main-600 hover-border-main-600 hover-bg-main-600 hover-text-white transition-1 position-absolute inset-inline-end-0 top-50 translate-middle-y z-3 ${!mobile && "text-2xl"} ${mobile ? "me-8" : "me-12"}`}
        style={{
          height: mobile ? "35px" : "default",
          width: mobile ? "35px" : "default",
        }}
      >
        <i className="ph-bold ph-arrow-right" />
      </button>
      <Slider ref={sliderRef} {...settings} className="banner-three__slider ">
        {sliderData.map((item, index) => (
          <div key={index}>
            <div
              className="banner-three__item background-img bg-img linear-overlay position-relative"
              style={{
                backgroundImage:
                  item?.attributes?.Image?.data?.attributes?.url &&
                  `url(${process.env.REACT_APP_strapiUrl}${item?.attributes?.Image?.data?.attributes?.url})`,
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-xxl-6 col-xl-8 col-lg-10 z-1">
                    <div className="banner-content ps-md-4">
                      <div className="flex-align gap-8 mb-16 wow bounceInDown">
                        <h5
                          className="mb-0 fw-medium text-shadow"
                          style={{ color: "#ffffff" }}
                        >
                          {item?.attributes?.Snippet}
                        </h5>
                      </div>
                      {index === 0 ? (
                        <h1
                          className={`${mobile || tab ? "display2" : "display4"} mb-24 text-neutral-200 fw-medium wow bounceInLeft text-shadow`}
                        >
                          {(item?.attributes?.Title || "")
                            .split(" ")
                            .slice(0, 4)
                            .join(" ")}{" "}
                          <span
                            className="text-yellow-600 wow bounceInRight"
                            data-wow-duration="2s"
                            data-wow-delay=".5s"
                            // style={{textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)'}}
                          >
                            {(item?.attributes?.Title || "")
                              .split(" ")
                              .slice(4, 12)
                              .join(" ")}
                          </span>{" "}
                          {(item?.attributes?.Title || "")
                            .split(" ")
                            .slice(12)
                            .join(" ")}
                        </h1>
                      ) : (
                        <h1
                          className={`${mobile || tab ? "display2" : "display4"} mb-24 text-neutral-900 fw-medium wow bounceInLeft text-shadow`}
                        >
                          {(item?.attributes?.Title || "")
                            .split(" ")
                            .slice(0, 2)
                            .join(" ")}{" "}
                          <span
                            className="text-yellow-600 wow bounceInRight"
                            data-wow-duration="2s"
                            data-wow-delay=".5s"
                          >
                            {(item?.attributes?.Title || "").split(" ")[2]}
                          </span>{" "}
                          {(item?.attributes?.Title || "")
                            .split(" ")
                            .slice(3)
                            .join(" ")}
                        </h1>
                      )}
                      <p className="text-white text-line-2 wow bounceInDown text-shadow">
                        {item?.attributes?.Description}
                      </p>
                    </div>
                    {index === 0 && (
                      <div
                        className={`buttons-wrapper flex-align flex-wrap gap-24 mt-40 ${!mobile && "ps-4"}`}
                      >
                        <Link
                          to="/admission"
                          className="btn btn-main rounded-pill flex-align gap-8  wow bounceInLeft"
                          data-wow-duration="1s"
                          data-wow-delay=".5s"
                        >
                          Apply Now
                          <i className="ph-bold ph-arrow-up-right d-flex text-lg" />
                        </Link>
                        {/* <div
                        className="flex-align gap-16  wow bounceInRight"
                        data-wow-duration="1s"
                        data-wow-delay=".5s"
                      >
                        <span
                          onClick={() => setIsOpen(true)}
                          className="play-button position-relative z-1 w-48 h-48 flex-center bg-main-two-600 text-white rounded-circle text-xl"
                        >
                          <i className="ph-fill ph-play" />
                        </span>
                        <Link
                          to="/course"
                          className="text-white hover-text-decoration-underline hover-text-main-two-600"
                        >
                          See All University
                        </Link>
                      </div> */}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
      {/* <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="XxVg_s8xAms"
        onClose={() => setIsOpen(false)}
        allowFullScreen
      /> */}
    </section>
  );
};

export default BannerThree;
